import styled from 'styled-components';
// import { backgroundVector } from '../../../assets/icons';

export const HomepageWrapper = styled.div`
    height: 100vh;
`;
